import React from 'react';
import SongTabsBar from './SongTabsBar';
import ResourceRowsPanel from './ResourceRowsPanel';

/**
 * English > Action Songs (also Vocal / Instrumental Songs and the rows added under them): the Action
 * Songs screen - its heading, a strip of song tiles, the selected song's resource rows and "Your
 * Practice" - showing the row's published lessons. CourseContentView keeps the behaviour (picking
 * the lesson, opening items, the quiz, the practice) and passes it in:
 * `lessons` (the row's), `activeId` / `onSelect`, `onOpenItem`, `quiz` (shown in place of
 * the rows while one is taken) and `practice`. `screen.icon` is the row's sidebar icon.
 */
export default function ActionSongsView({ title, screen = {}, lessons, activeId, onSelect, onOpenItem, quiz, practice }) {
  const activeSong = lessons.find((song) => song.id === activeId) || lessons[0];

  return (
    <>
      <div className="flex items-center gap-4 mb-6">
        <span className="text-5xl font-extrabold text-violet-600 leading-none" aria-hidden="true">
          ♫
        </span>
        <div>
          <h1 className="text-[28px] font-extrabold text-slate-900 leading-tight">{title}</h1>
          <p className="text-[15px] font-medium text-gray-500">Sing, move and enjoy learning!</p>
        </div>
      </div>

      {activeSong ? (
        <>
          <SongTabsBar songs={lessons} activeSongId={activeSong.id} onSelectSong={onSelect} emoji={screen.icon} />

          <div className="grid grid-cols-1 [@container_(min-width:900px)]:grid-cols-[minmax(0,1fr)_minmax(360px,33.333%)] gap-6 items-start">
            <div className="min-w-0">{quiz || <ResourceRowsPanel chapter={activeSong} onOpenItem={onOpenItem} />}</div>
            {practice}
          </div>
        </>
      ) : (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-10 text-center">
          <p className="text-[15px] font-semibold text-gray-500">No lessons have been added here yet.</p>
        </div>
      )}
    </>
  );
}
